import React, {FC, useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {CompanyModel} from '../../../../model'
import {getCompanyById} from '../../../../services'
import {useCentral} from '../../../../../../hooks/useCentral'
import {useEnterprise} from '../../../../hooks'
import {initValues} from '../../../../util/values/company'
import AditionalForm from '../../../../../../components/UI/Form/aditionalCamp/aditionalCampCentral'
import ContentForm from '../../../../../../components/UI/Form/contentForm'
import {TITLE_FORM_COMPANY} from '../../../../util/Constants'
import {SelectWrapper} from '../../../../../../components/UI/Form/Input'
const Index: FC = () => {
  const {setValue} = useFormContext()
  const {currentTabItem} = useCentral()
  const {enterprise, getEnterpriseList} = useEnterprise()

  const getCompanyByIdValues = async () => {
    try {
      const response = await getCompanyById(currentTabItem.idToEdit)
      const data = response.data.data
      type CompanyModelKeys = keyof CompanyModel

      for (const fieldName in initValues) {
        if (initValues.hasOwnProperty(fieldName)) {
          if (data.hasOwnProperty(fieldName)) {
            if (data[fieldName as CompanyModelKeys]) {
              if (fieldName === 'campoadicionalFec1') {
                let valueDep = data[fieldName as CompanyModelKeys]

                if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                  const fechaLocal = new Date(valueDep)
                  const formattedDate = fechaLocal.toISOString().slice(0, 10)
                  setValue(fieldName, formattedDate)
                }
              } else if (fieldName === 'campoadicionalFec2') {
                let valueDep = data[fieldName as CompanyModelKeys]
                if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                  const fechaLocal = new Date(valueDep)
                  const formattedDate = fechaLocal.toISOString().slice(0, 10)
                  setValue(fieldName, formattedDate)
                }
              } else {
                setValue(fieldName, data[fieldName as CompanyModelKeys])
              }
            } else {
              setValue(fieldName, '')
            }
          }
        }
      }
    } catch (error) {
      console.error('Error al obtener la lista de países:', error)
    }
  }
  useEffect(() => {
    getEnterpriseList()
  }, [])

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getCompanyByIdValues()
    }
  }, [currentTabItem.idToEdit])
  let isDisabled = currentTabItem.idToEdit ? true : false

  return (
    <ContentForm isEdit={isDisabled} title={TITLE_FORM_COMPANY}>
      <div className='row'>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Empresa'
            name='empresaId'
            data={enterprise}
            disabled={isDisabled}
            required
          />
        </div>
      </div>
      <hr className='divider' />
      <AditionalForm />
    </ContentForm>
  )
}

export default Index
